<template>
  <div :class="{'d-flex justify-content-center flex-column': isMobile}">
    <b-button id="feedback-button" variant="link" :class="{'text-light': !isMobile}" class="p-0 feedback-button">
      <font-awesome-icon :icon="['fas', 'bullhorn']" size="sm" class="mr-2" />{{ $t('Feedback?') }}
    </b-button>
    <p v-if="isMobile" class="text-center small mb-0">
      {{ $t('Help us improve your dashboard') }}
    </p>
    <b-tooltip id="feedback-tooltip" ref="tooltip" class="px-0" target="feedback-button" triggers="click" @show="onShow()" @hide="onHide()">
      <validation-observer v-if="!feedbackSent">
        <validation-provider ref="validation" v-slot="{validated, errors, dirty, valid, invalid}" rules="required">
          <b-form-textarea
            v-model="message"
            class="mb-3 feedback-textarea rounded-0"
            :placeholder="isMobile ? $t('Let us know how we can improve your dashboard') : $t('Help us improve this page')"
            rows="5"
            :state="(dirty || validated) ? (valid ? null : false) : null"
          />
          <b-form-invalid-feedback :state="invalid" :force-show="invalid">
            <div class="px-2 mb-3">
              {{ errors[0] }}
            </div>
          </b-form-invalid-feedback>
        </validation-provider>
        <div class="d-flex flex-row justify-content-end px-2">
          <b-button variant="outline-secondary" size="sm" @click="onCancel">
            {{ $t('Cancel') }}
          </b-button>
          <b-button class="ml-2" variant="primary" size="sm" @click="onSend">
            {{ $t('Send Feedback') }}
          </b-button>
        </div>
      </validation-observer>
      <div v-else>
        <p class="p-2 m-0">
          {{ $t('Thank you for your feedback.') }}
        </p>
      </div>
    </b-tooltip>
    <div
      v-if="!isMobile & backdropVisible"
      class="tooltip-backdrop position-fixed d-none d-lg-block"
      @click="onCancel()"
    />
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import userDevice from "@/imports/mixins/userDevice";

export default {
  name: "Feedback",
  components: {ValidationProvider, ValidationObserver},
  mixins: [userDevice],
  data() {
    return {
      message: '',
      backdropVisible: false,
      feedbackSent: false,
    };
  },
  methods: {
    onShow() {
      this.backdropVisible = true;
      this.feedbackSent = false;
      this.message = '';
    },
    onHide() {
      this.backdropVisible = false;
    },
    onCancel() {
      this.$refs.tooltip.$emit('close')
    },
    onSend() {
      this.$refs.validation.validate().then(({valid}) => {
        if (!valid) {
          return;
        }
        this.$api.contact.installerFeedback(this.message, window.document.location.href)
          .finally(() => this.feedbackSent = true);
      });
    },
  },
}
</script>

<style scoped lang="scss">
  ::v-deep .tooltip-inner {
    padding: 0 0 .5rem;
    border-radius: .375rem;
    overflow: hidden;
    max-width: 325px;
  }

  .tooltip-backdrop {
    opacity: 1;
    background: rgba(1,54,82,.2);
    top: 0;
    left: 0;
    z-index: 12;
    width: 100vw;
    height: 100vh;
  }

  .feedback-textarea {
    border: 0;
    border-bottom: 1px solid $border-color;
    @include media-breakpoint-down(lg) {
      width: 250px;
    }

    @include media-breakpoint-up(xl) {
      width: 450px;
    }
}

.feedback-button {
  @include font-size($font-size-15);
}
</style>
